var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayCircledInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.05333 0 0 6.05333 0 13.5C0 20.9467 6.05333 27 13.5 27C20.9467 27 27 20.9467 27 13.5C27 6.05333 20.9467 0 13.5 0ZM13.5 1.54286C20.1128 1.54286 25.4571 6.88717 25.4571 13.5C25.4571 20.1128 20.1128 25.4571 13.5 25.4571C6.88716 25.4571 1.54286 20.1128 1.54286 13.5C1.54286 6.88717 6.88716 1.54286 13.5 1.54286ZM10.5469 7.71429C9.865 7.73014 9.27457 8.29236 9.25714 9.10045V17.8875C9.28044 18.9649 10.3296 19.6178 11.246 19.1049L18.6107 14.6933C19.0121 14.4526 19.2857 14.0167 19.2857 13.5C19.2857 12.9833 19.0121 12.5353 18.6107 12.2946L11.246 7.89509C11.0169 7.76686 10.7742 7.70901 10.5469 7.71429Z",
    fill: "#E8B07E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircledInactive);
export default __webpack_public_path__ + "static/media/playCircledInactive.2b854d0039300c9f8f6ac462f7c17e83.svg";
export { ForwardRef as ReactComponent };